import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleCompleteGuide from "../pages/articles/vigorbuy-spreadsheet-complete-guide/page";
import ArticleBestSpreadsheet from "../pages/articles/best-vigorbuy-spreadsheet-2026/page";
import ArticleSafetyGuide from "../pages/articles/how-to-use-vigorbuy-spreadsheet-safely/page";
import ArticleShoesGuide from "../pages/articles/vigorbuy-spreadsheet-shoes-guide/page";
import ArticleHoodiesGuide from "../pages/articles/vigorbuy-spreadsheet-hoodies-collection/page";
import ArticleSafeReview from "../pages/articles/is-vigorbuy-safe-review/page";
import ArticleBeginners from "../pages/articles/vigorbuy-spreadsheet-beginners/page";
import ArticleShipping from "../pages/articles/vigorbuy-shipping-guide/page";
import ArticleQCGuide from "../pages/articles/vigorbuy-qc-guide/page";
import ArticleProTips from "../pages/articles/vigorbuy-spreadsheet-pro-tips/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articles/vigorbuy-spreadsheet-complete-guide",
    element: <ArticleCompleteGuide />,
  },
  {
    path: "/articles/best-vigorbuy-spreadsheet-2026",
    element: <ArticleBestSpreadsheet />,
  },
  {
    path: "/articles/how-to-use-vigorbuy-spreadsheet-safely",
    element: <ArticleSafetyGuide />,
  },
  {
    path: "/articles/vigorbuy-spreadsheet-shoes-guide",
    element: <ArticleShoesGuide />,
  },
  {
    path: "/articles/vigorbuy-spreadsheet-hoodies-collection",
    element: <ArticleHoodiesGuide />,
  },
  {
    path: "/articles/is-vigorbuy-safe-review",
    element: <ArticleSafeReview />,
  },
  {
    path: "/articles/vigorbuy-spreadsheet-beginners",
    element: <ArticleBeginners />,
  },
  {
    path: "/articles/vigorbuy-shipping-guide",
    element: <ArticleShipping />,
  },
  {
    path: "/articles/vigorbuy-qc-guide",
    element: <ArticleQCGuide />,
  },
  {
    path: "/articles/vigorbuy-spreadsheet-pro-tips",
    element: <ArticleProTips />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;